export interface CustomModalModel {
  title: string;
  message: { value: string; type?: ModalMessageType, image?: string };
  cancel_button?: { label?: string; customizer?: Customizer; visible?: boolean, disabled?: boolean };
  validate_button?: { label?: string; customizer?: Customizer; visible?: boolean, disabled?: boolean };
  close_button?: { visible?: boolean, disabled?: boolean };
  customizer?: Customizer;
  disable_close?: boolean;
}

interface Customizer {
  color?: string;
  background?: string;
  font_size?: string;
  size?: { width: string; height?: string };
}

export enum ModalMessageType {
  HTML = 'html',
  TEXT = 'text'
}
